function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import { opacity, space } from 'styled-system';
import { deviceMediaQueries } from '../../theme';
import { createBreakpointMap } from '../helpers/styled-helpers';
import { generateColorMapDeviceCSS, typographyTypeStyleMap } from './style';
export default class Typography extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "StyledTypography", void 0);

    var typographyTypeBreakpointMap = createBreakpointMap(props.type);
    var colorMap;

    if (props.color) {
      colorMap = createBreakpointMap(props.color);
    }

    var textAlignMap;

    if (props.textAlign) {
      textAlignMap = createBreakpointMap(props.textAlign);
    }

    var fontSizeMap;

    if (props.fontSize) {
      fontSizeMap = createBreakpointMap(props.fontSize);
    }

    this.StyledTypography = styled.div.withConfig({
      displayName: "typography__StyledTypography",
      componentId: "sc-1pjd5pb-0"
    })(["", "{", ";", ";", ";", "}", "{", ";", ";", ";", "}", "{", ";", ";", ";", "}", ";", ";"], deviceMediaQueries.mobile, typographyTypeStyleMap["".concat(typographyTypeBreakpointMap.mobile, "Styles")], textAlignMap && "text-align: ".concat(textAlignMap.mobile), fontSizeMap && "font-size: ".concat(fontSizeMap.mobile, "px"), generateColorMapDeviceCSS('mobile', colorMap), deviceMediaQueries.tablet, typographyTypeStyleMap["".concat(typographyTypeBreakpointMap.tablet, "Styles")], textAlignMap && "text-align: ".concat(textAlignMap.tablet), fontSizeMap && "font-size: ".concat(fontSizeMap.tablet, "px"), generateColorMapDeviceCSS('tablet', colorMap), deviceMediaQueries.desktop, typographyTypeStyleMap["".concat(typographyTypeBreakpointMap.desktop, "Styles")], textAlignMap && "text-align: ".concat(textAlignMap.desktop), fontSizeMap && "font-size: ".concat(fontSizeMap.desktop, "px"), generateColorMapDeviceCSS('desktop', colorMap), opacity, space);
  }

  render() {
    var StyledTypography = this.StyledTypography;

    var _this$props = this.props,
        {
      as,
      forwardedAs,
      htmlFor,
      className,
      type,
      color: colorProp,
      opacity: opacityProp
    } = _this$props,
        spaceProps = _objectWithoutProperties(_this$props, ["as", "forwardedAs", "htmlFor", "className", "type", "color", "opacity"]);

    var additionalProps = {};

    if (htmlFor) {
      additionalProps.htmlFor = htmlFor;
    }

    return /*#__PURE__*/React.createElement(StyledTypography, _extends({
      as: as || forwardedAs,
      className: className,
      color: colorProp,
      opacity: opacityProp
    }, spaceProps, additionalProps), this.props.children);
  }

}